(function () {
  function isValidPartnerValue(value) {
    var normalized = String(value || '').trim()
    return Boolean(
      normalized &&
        normalized !== '<-- To Be Specified -->' &&
        normalized !== 'NA' &&
        normalized !== '--NONE--',
    )
  }

  function isValidPincode(pincode) {
    var normalized = String(pincode || '').trim()
    return isValidPartnerValue(normalized) && !/^0+$/.test(normalized)
  }

  function getPartnerInitials(name) {
    return String(name || '')
      .split(' ')
      .filter(Boolean)
      .map(function (word) {
        return word[0]
      })
      .slice(0, 2)
      .join('')
      .toUpperCase()
  }

  function buildPartnerAddress(partner) {
    var addressParts = []

    if (isValidPartnerValue(partner && partner.address)) {
      addressParts.push(String(partner.address).trim())
    }
    if (isValidPartnerValue(partner && partner.city)) {
      addressParts.push(String(partner.city).trim())
    }
    if (isValidPartnerValue(partner && partner.state)) {
      addressParts.push(String(partner.state).trim())
    }
    if (isValidPincode(partner && partner.pincode)) {
      addressParts.push(String(partner.pincode).trim())
    }
    if (isValidPartnerValue(partner && partner.country)) {
      addressParts.push(String(partner.country).trim())
    }

    return addressParts.join(', ')
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }

  function renderResultMessage(container, text) {
    container.innerHTML =
      '<div class="col-span-full flex min-h-24 items-center justify-center">' +
      '<p class="text-center text-sm font-medium text-muted-light dark:text-muted-dark">' +
      escapeHtml(text) +
      '</p>' +
      '</div>'
  }

  function renderPartnerCards(container, listing, noDataText) {
    if (!Array.isArray(listing) || !listing.length) {
      renderResultMessage(container, noDataText)
      return
    }

    var canOpenModal = Boolean(
      document.querySelector('[data-partner-contact-modal]'),
    )

    var cards = listing
      .map(function (partner) {
        var partnerName =
          partner && partner.partner_name
            ? String(partner.partner_name).trim()
            : 'BUSY Partner'
        var contactName =
          partner && partner.contact_person
            ? String(partner.contact_person).trim()
            : 'Support Team'
        var partnerPin =
          partner && partner.pin ? String(partner.pin).trim() : ''
        var address = buildPartnerAddress(partner)

        var safePartnerName = escapeHtml(partnerName)
        var safeContactName = escapeHtml(contactName)
        var safeAddress = escapeHtml(address || 'Address details not available.')
        var safePin = escapeHtml(partnerPin)
        var safeInitials = escapeHtml(getPartnerInitials(contactName || partnerName))
        var cardClass =
          'group rounded-3xl border border-border-light bg-surface-light p-6 shadow-elev-1 transition-colors duration-200 dark:border-border-dark dark:bg-surface-dark'
        if (canOpenModal) {
          cardClass +=
            ' cursor-pointer hover:border-primary/25 hover:bg-primary/5 hover:shadow-elev-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 dark:hover:bg-primary/10'
        }
        var triggerAttrs = ''
        if (canOpenModal) {
          triggerAttrs =
            ' role="button" tabindex="0" data-partner-contact-open data-partner-name="' +
            safePartnerName +
            '" data-partner-address="' +
            safeAddress +
            '" data-partner-contact="' +
            safeContactName +
            '" data-partner-pin="' +
            safePin +
            '"'
        }
        var clickIcon = canOpenModal
          ? '<span aria-hidden="true" class="material-icons-outlined ml-auto text-base text-muted-light transition-colors duration-200 group-hover:text-primary dark:text-muted-dark" data-icon="arrow_outward"></span>'
          : ''

        return (
          '<article class="' +
          cardClass +
          '"' +
          triggerAttrs +
          '>' +
          '<div class="mb-4 flex items-start gap-3">' +
          '<div class="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-primary/10 text-base font-bold text-primary">' +
          safeInitials +
          '</div>' +
          '<div class="min-w-0">' +
          '<h3 class="truncate text-base font-bold text-text-light dark:text-text-dark" title="' +
          safeContactName +
          '">' +
          safeContactName +
          '</h3>' +
          '<p class="mt-1 truncate text-sm font-medium text-muted-light dark:text-muted-dark" title="' +
          safePartnerName +
          '">' +
          safePartnerName +
          '</p>' +
          '</div>' +
          clickIcon +
          '</div>' +
          '<p class="line-clamp-3 min-h-18 text-sm leading-relaxed text-muted-light dark:text-muted-dark" title="' +
          safeAddress +
          '">' +
          safeAddress +
          '</p>' +
          '</article>'
        )
      })
      .join('')

    container.innerHTML = cards
  }

  async function fetchPartners(endpoint) {
    var response = await fetch(endpoint, {
      headers: {
        Ajax: 'true',
      },
    })

    if (!response.ok) {
      throw new Error('Failed to fetch partners')
    }

    var payload = await response.json()
    return payload && payload.data && Array.isArray(payload.data.listing)
      ? payload.data.listing
      : []
  }

  function initTabs(root) {
    var tabButtons = Array.from(
      root.querySelectorAll('[data-network-tab-btn]'),
    )
    var tabPanels = Array.from(root.querySelectorAll('[data-network-panel]'))
    if (!tabButtons.length || !tabPanels.length) return function () {}

    var activateTab = function (tabName) {
      tabButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-network-tab') === tabName
        button.classList.toggle('bg-primary', isActive)
        button.classList.toggle('text-white', isActive)
        button.classList.toggle('text-muted-light', !isActive)
        button.classList.toggle('dark:text-muted-dark', !isActive)
        button.classList.toggle('hover:text-primary', !isActive)
      })

      tabPanels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-network-panel') === tabName
        panel.hidden = !isActive
        panel.classList.toggle('hidden', !isActive)
      })
    }

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activateTab(button.getAttribute('data-network-tab') || 'india')
      })
    })

    activateTab('india')
    return activateTab
  }

  function initOurNetwork() {
    var root = document.querySelector('[data-our-network]')
    if (!root) return
    if (root.dataset.networkBound === 'true') return
    root.dataset.networkBound = 'true'

    initTabs(root)

    var stateSelect = root.querySelector('[data-network-state-select]')
    var countrySelect = root.querySelector('[data-network-country-select]')
    var indiaResults = root.querySelector('[data-network-results="india"]')
    var overseasResults = root.querySelector('[data-network-results="overseas"]')

    if (stateSelect && indiaResults) {
      stateSelect.addEventListener('change', async function () {
        var selectedState = stateSelect.value
        if (!selectedState) {
          renderResultMessage(indiaResults, 'Select a state to view partners.')
          return
        }

        renderResultMessage(indiaResults, 'Loading partners...')
        try {
          var stateListing = await fetchPartners(
            '/our-network/state/' + encodeURIComponent(selectedState) + '/',
          )
          renderPartnerCards(
            indiaResults,
            stateListing,
            'No partners found for this state.',
          )
        } catch (_error) {
          renderResultMessage(
            indiaResults,
            'Unable to load partners right now. Please try again.',
          )
        }
      })
    }

    if (countrySelect && overseasResults) {
      countrySelect.addEventListener('change', async function () {
        var selectedCountry = countrySelect.value
        if (!selectedCountry) {
          renderResultMessage(
            overseasResults,
            'Select a country to view partners.',
          )
          return
        }

        renderResultMessage(overseasResults, 'Loading partners...')
        try {
          var countryListing = await fetchPartners(
            '/our-network/country/' +
              encodeURIComponent(selectedCountry) +
              '/',
          )
          renderPartnerCards(
            overseasResults,
            countryListing,
            'No partners found for this country.',
          )
        } catch (_error) {
          renderResultMessage(
            overseasResults,
            'Unable to load partners right now. Please try again.',
          )
        }
      })
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOurNetwork, { once: true })
  } else {
    initOurNetwork()
  }
})()
